<template>
  <section class="six-page-section media_section_height">
    <div class="six-page-section-box media_screen_style"
      style="display: flex; flex-direction: column; align-items: center">
      <div style="color: #fff6f6; font-size: 32px; margin-bottom: 16px" class="shake2">
        {{ t("six.title") }}
      </div>
      <div style="color: #fef8f8; font-size: 16px; margin: 0 12px 32px 12px;max-width: 450px;">
        {{ t("six.details") }}
      </div>
      <div class="six_img_bg">
        <!-- <img src="../assets/7_test.png" style="position: absolute;top: 0;left: 0;opacity: 0.5;" width="300px" alt="" /> -->
        <img src="../assets/7.webp" width="300px" style="z-index: 100;" alt="" />
        <transition>
          <div class="subtitle_switch">
            <img v-show="!swich" src="../assets/subtitle_close.svg" width="15px" alt="" />
            <img v-show="swich" src="../assets/subtitle_open.svg" width="15px" alt="" />
          </div>
        </transition>

        <!-- <transition>
          <img v-if="!hasAnimated" class="audio_animate" src="../assets/audio_animate.svg" width="150px" alt="" />
        </transition> -->

        <div ref="SixContainer" class="six_img_bg_txt_list">
          <div v-for="(item, index) in displayedMessages" :key="index" class="txt_item_box"
            :style="item.dir ? 'flex-direction: row-reverse;' : null">
            <div class="box_left" :style="item.dir ? 'margin-left:6px' : 'margin-right:6px'">
              {{ item.name[0] }}
            </div>
            <div class="box_right" :style="item.dir ? ' align-items: flex-end' : ' align-items: flex-start'
              ">
              <div class="right_name" style="color: rgba(255, 255, 255, 0.6); margin-bottom: 2px">
                {{ item.name }}
              </div>
              <div class="right_txt" :style="item.dir ? 'margin-left:32px' : 'margin-right:32px'">
                {{ item.txt }}
              </div>
            </div>
          </div>
        </div>

        <div class="six_bottom_box">
          <div style="margin-bottom: 20px;font-size: 13px;">{{ t("six.one") }}</div>
          <div style="margin-bottom: 20px;font-size: 24px;font-weight: 600;">00 : 00 : 10</div>
          <div style="font-size: 13px; color: #40fff9;">{{ t("six.two") }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from "vue";
const SixContainer = ref(null);
import { useI18n } from "vue-i18n";

const { t, locale } = useI18n();

const lang = ref("zh");
if (locale.value != 'zh-CN' && locale.value != 'zh') {
  lang.value = "en";
}

const messages = lang.value == "en" ? [
  {
    name: "eNewie",
    txt: ["eNewie LingXi", " provide ", "professional", " services."],
    dir: false,
  },
  {
    name: "eNewie",
    txt: ["We contribute", " our exceptional abilities", " to every", " session", " with a professional spirit."],
    dir: false,
  },
  {
    name: "eNewie",
    txt: ["Now", " we use cloud-based", " simultaneous interpretation", " to connect with every listener."],
    dir: false,
  }
] : [
  {
    name: "eNewie",
    txt: ["译牛灵犀", "提供专业服务。"],
    dir: false,
  },
  {
    name: "eNewie",
    txt: ["以专业的", "精神", "为每一场", "会话贡献", "我们卓越的能力。"],
    dir: false,
  },
  {
    name: "eNewie",
    txt: ["现在", "我们用云同传", "的方式连接每一位", "听众。"],
    dir: false,
  }
];


const displayedMessages = ref([]);
const hasAnimated = ref(false);

const time = lang.value == "en" ? 20 : 50;

function typeLine(line) {
  return new Promise((resolve) => {
    const interval = setTimeout(() => {
      clearInterval(interval);
      resolve(line);
    }, line.length * time);
  });
}

async function playMessages() {
  for (let i = 0; i < messages.length; i++) {
    const msg = messages[i];
    const newMsg = { ...msg, txt: "", otxt: "" };
    displayedMessages.value.push(newMsg);
    for (const line of msg.txt) {
      const typed = await typeLine(line);
      displayedMessages.value[i].txt = displayedMessages.value[i].txt + typed;
    }
  }
  setTimeout(() => {
    displayedMessages.value = [];
    playMessages(); // 递归调用形成循环
  }, 2000); // 2秒后清空并重播
}
const swich = ref(false);
onMounted(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting && !hasAnimated.value) {
        hasAnimated.value = true;
        setTimeout(() => {
          swich.value = true;
          playMessages();
        }, 500);
        observer.disconnect();
      }
    },
    {
      threshold: 0.9,
    }
  );

  if (SixContainer.value) {
    observer.observe(SixContainer.value);
  }
});
</script>

<style scoped>
.six-page-section {
  /* transform: scale(.7);
  transform-origin: top; */
  /* height: 100vh; */
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 32px;
  /* min-height: 932px; */
}

.six_img_bg {
  position: relative;
  width: 300px;
  height: 666px;
}

.audio_animate {
  position: absolute;
  z-index: 100;
  top: 150px;
  left: 50%;
  transform: translate(-50%, 0%);
  animation: audioAnimateScale 1.5s infinite ease-in-out;
}

@keyframes audioAnimateScale {
  0% {
    transform: translate(-50%, 0%) scale(1);
    opacity: 1;
  }

  50% {
    transform: translate(-50%, 0%) scale(1.5);
    opacity: 0.6;
  }

  100% {
    transform: translate(-50%, 0%) scale(1);
    opacity: 1;
  }
}

/* -----------------文本列表 */
.six_img_bg_txt_list {
  display: flex;
  flex-direction: column-reverse;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0%);
  bottom: 280px;
  width: 300px;
  height: 300px;
  /* background-color: aliceblue; */
  overflow: auto;
  z-index: 100;
}

.txt_item_box {
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  margin: 6px 12px;
  margin-top: 12px;
}

.box_right {
  display: flex;
  flex-direction: column;

  color: rgba(255, 255, 255, 0.6);
}

.box_left {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 12px;
  background-color: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.6);

  width: 35px;
  height: 35px;
  border-radius: 35px;
  margin-right: 6px;
}

.right_txt {
  text-align: left;
  color: rgba(255, 255, 255, 0.8);
  height: 40px;
}

/* --动画-- */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 字幕快关 */
.subtitle_switch {
  position: absolute;
  right: 14px;
  top: 100px;
  z-index: 100;
}

.six_bottom_box {
  position: absolute;
  bottom: 128px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0.9;
}
</style>
